import React from "react";
import EditorCanvasView from "components/editor_canvas/editor_canvas_view";
import uuid from 'uuid/v4'
import Types from 'components/editor_canvas/editor_canvas_element_types';
import EditorCanvasDragLayer from "components/editor_canvas/editor_canvas_drag_layer";
import {dbPlacedItems, auth} from "components/firebase";
import {MAsset} from "components/tools_pane/tools_items";
import {Localization} from "localizations/languages";

class EditorCanvas extends React.Component {
    static STORY_TITLE_ID = 'story-title';
    transforming = false;
    placedItems = {};

    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 1,
            maxZIndex: 0,
            placedItems: {},
            editedItemUuid: null,
        };
        this.canvasRef = React.createRef();
        if (!!props.getCanvasRef) props.getCanvasRef(this.canvasRef);
        this.resizeListener = this.handleResize.bind(this);
        this._loadData();
        this.storyUnsubscribe = this.story.onSnapshot(change => {
            this.storyData = change.data();
            this.setState({
                placedItems: this.placedItems
            });
            this.storyUnsubscribe();
        });
    }

    _loadData() {
        this.story = this.props.story;
        if (!this.props.storyDoc || this.props.page === undefined) return;
        this.placedItems = {};
        this.storyDoc = this.props.storyDoc;
        this.page = this.props.page;
        if (!!this.unsubscribe) this.unsubscribe();
        this.unsubscribe = dbPlacedItems
            .where('owner', '==', this.storyDoc.data().owner)
            .where('story', '==', this.story)
            .where('page', '==', this.page)
            .onSnapshot((snapshot => {
                snapshot.docChanges().forEach((change) => {
                    let data = change.doc.data();
                    if (change.type === 'removed') {
                        delete this.placedItems[data.uuid];
                    } else {
                        this.placedItems[data.uuid] = data;
                    }
                });
                this.setState({
                    placedItems: this.placedItems
                });
            }));
    }

    render() {
        return <div onClick={() => this._onPlacedItemClick(null)} style={{zIndex: 0}}>
            <EditorCanvasView
                canvasRef={this.canvasRef}
                onDrop={(item, monitor) => this.onDrop(item, monitor)}
                readOnly={this.props.readOnly}
                onPlacedItemClick={(uuid) => this._onPlacedItemClick(uuid)}
                onTransformStart={(pitem) => this.onTransformStart(pitem)}
                onTitleUpdate={(pitem) => this.onTitleUpdate(pitem)}
                onTextFocus={this.onTextFocus}
                onTransformEnd={(pitem) => this.onTransformEnd(pitem)}
                storyData={this.storyData}
                {...this.state} {...this.props}
            />
            <EditorCanvasDragLayer canvasRef={this.canvasRef} {...this.props}/>
        </div>;
    }

    onTitleUpdate(pitem) {
    }

    onTransformStart(pitem) {
        this.transforming = true;
        if (!!this.props.onDragStart) this.props.onDragStart();
        this._onPlacedItemClick(pitem.uuid);
    }

    onTransformEnd(pitem) {
        setTimeout(() => {
            this.transforming = false;
            if (!!this.props.onDragEnd) this.props.onDragEnd();
        }, 100);
    }

    _onPlacedItemClick(uuid) {
        if (uuid === null) {
            if (this.transforming) {
                this.transforming = false;
                return;
            }
            this.setState({editedItemUuid: null});
            this.props.closeAllPanes();
            return;
        }
        this.setState({editedItemUuid: uuid});
    }

    _getDropPosition(monitor) {
        const canvasRect = this.canvasRef.current.getBoundingClientRect();
        let pointer = monitor.getInitialClientOffset();
        let component = monitor.getInitialSourceClientOffset();
        let x = monitor.getClientOffset().x - canvasRect.x + (component.x - pointer.x);
        let y = monitor.getClientOffset().y - canvasRect.y + (component.y - pointer.y);
        let h = canvasRect.height;
        let w = canvasRect.width;
        return {x: x / w * 100, y: y / h * 100};
    }

    getMeta(url) {
        return new Promise((resolve, reject) => {
            let img = new Image();
            img.onload = () => resolve(img);
            img.onerror = reject;
            img.src = url;
        });
    }

    static getTitlePlacedItem() {
        let pitem = EditorCanvas.defaultPlacedItem.get(Types.PLACED_TEXTBOX);
        pitem.textOverlay.content = Localization.current.translation1;
        pitem.textOverlay.styles = {
            fontWeight: 'bold',
            color: 'white',
            fontSize: 3.4,
            textShadow: '2px 2px 20px #000000'
        };
        pitem.position.x = 88;
        pitem.position.y = 40;
        pitem.position.scaleX = 20;
        pitem.position.scaleY = 2.6;
        pitem.position.width /= 2;
        pitem.position.height /= 2;
        pitem.uuid = EditorCanvas.STORY_TITLE_ID;
        return pitem;
    }

    async _getPlacedItem(item, position) {
        let pitem = EditorCanvas.defaultPlacedItem.get(item.objType);
        pitem.asset = item.asset_n;
        let meta;
        let pos = pitem.position;
        pos.x = position.x;
        pos.y = position.y;
        if (!!item.meta) {
            meta = item.meta;
            pos.width = meta.width;
            pos.height = meta.height;
            if (meta.x !== undefined && meta.y !== undefined) {
                pos.x = meta.x;
                pos.y = meta.y;
            }
            pitem.meta = meta;
        } else {
            meta = await this.getMeta(MAsset.get(pitem).img);
            let aspect = meta.width / meta.height;

            if (meta.width < meta.height) {
                pos.scaleX = aspect;
                pos.x -= (1 - aspect) * pos.width / 2 / 1.78
            } else {
                pos.scaleY = 1 / aspect;
                pos.y -= (1 - 1 / aspect) * pos.width / 2
            }
        }
        this.setState({maxZIndex: pitem.zIndex});
        return pitem;
    }

    async _handleElementDrop(monitor) {
        let itemPosition = this._getDropPosition(monitor);
        let item = monitor.getItem();
        let placedItem = await this._getPlacedItem(item, itemPosition);
        this.setState({
            placedItems: {
                ...this.state.placedItems,
                [placedItem.uuid]: placedItem
            }
        });
        this._savePlacedItem(placedItem);
    }

    onDrop(i, monitor) {
        if (monitor === undefined) return;
        let type = monitor.getItemType();
        switch (type) {
            case Types.ELEMENT:
                this._handleElementDrop(monitor);
                break;
        }
        this.props.onDragEnd();
    }

    onTabClick(i) {
        this.setState({selectedTab: i});
    }

    bgClick(i) {
        this.props.bgClick(i);
    }

    static defaultPlacedItem = {
        get: (type) => ({
            uuid: uuid(),
            freeTransform: false,
            position: EditorCanvas.defaultPlacedItem.position(),
            asset: null,
            type: type,
            styles: {},
            textOverlay: EditorCanvas.defaultPlacedItem.textOverlay()
        }),
        textOverlay: () => ({
            styles: {
                fontWeight: 'bold',
                fontSize: 2.0
            },
            content: ""
        }),
        position: () => ({
            x: 0,
            y: 0,
            rotation: 0.0,
            width: 15,
            height: 15,
            scaleX: 1,
            scaleY: 1,
            zIndex: 3,
        })
    };

    handleResize(e) {
        let canvasRect = this.canvasRef.current.getBoundingClientRect();
        this._calcCanvasOffset();
        this.setState({canvasRect});
    }

    componentDidMount() {
        window.addEventListener("resize", this.resizeListener);
        this._calcCanvasOffset();
        this.setState({
            canvasRect: this.canvasRef.current.getBoundingClientRect(),
        })
    }

    _calcCanvasOffset() {
        let w = window.innerWidth;
        let h = window.innerHeight;
        let aspect = w / h;
        let canvasOffsetX = 0;
        let canvasOffsetY = 0;
        let targetAspect = 16 / 9;
        if (aspect > targetAspect) {
            canvasOffsetX = (w - h * targetAspect) / 2;
            this.setState({
                    canvasOffsetX,
                    canvasOffsetY
                }
            );
        } else {
            canvasOffsetY = (h - w / targetAspect) / 2;
            this.setState({
                    canvasOffsetX,
                    canvasOffsetY
                }
            );
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resizeListener);
        if (!!this.unsubscribe) this.unsubscribe();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.story !== this.props.story || prevProps.page !== this.props.page) {
            this._loadData();
            this.setState({
                placedItems: []
            });
        }
    }

    _savePlacedItem(pitem) {
        if (!pitem) return;
        pitem.user = auth.currentUser.uid;
        pitem.story = this.story;
        pitem.page = this.page;
        pitem.owner = auth.currentUser.uid;
        dbPlacedItems.doc(pitem.uuid).set(pitem, {merge: true});
    }
}

export default EditorCanvas;